import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import {
    POST_NLP_SCORE
} from '@/constants/ApiConstants';

const state = {};

const getters = {};

const mutations = {};

const actions = {
    [action.POST_NLP_SCORE](_, data) {
        return ApiService.post(POST_NLP_SCORE, data);
    },
};

export default {
    state,
    actions,
    getters,
    mutations
}